import { Tooltip, Flex, Icon, Text } from '@welbe/design-system';

type SectionIconTextProps = {
	icon: any;
	label: string;
};

export const SectionIconText = ({ icon, label }: SectionIconTextProps) => {
	return (
		<Flex gap="0.5rem" alignItems="center" maxW="160px">
			<Icon color="blue.500">{icon}</Icon>
			<Tooltip content={label}>
				<Text fontSize="xs" fontWeight="500" color="fg.muted" truncate>
					{label}
				</Text>
			</Tooltip>
		</Flex>
	);
};
